<dx-scroll-view data-testid="single-card-scroll-view" height="100%" width="100%" class="with-footer single-card">
  <div data-testid="single-card-content" class="dx-card content">
    <div data-testid="single-card-header" class="header">
      <div data-testid="single-card-title" class="title">{{title}}</div>
      <div data-testid="single-card-description" class="description">{{description}}</div>
    </div>
    <ng-content></ng-content>
  </div>
</dx-scroll-view>
